import { createSelector } from 'reselect';

export const getExpenses = state => state.expenses.data;

export const getExpensesList = createSelector([getExpenses], expenses =>
  Object.values(expenses)
);

export const getExpensesByBookingId = createSelector(
  [getExpensesList],
  expenses => {
    return (expenses || []).reduce((acc, expense) => {
      if (!expense.archived) {
        return {
          ...acc,
          [expense.booking_id]: acc[expense.booking_id]
            ? [...acc[expense.booking_id], expense]
            : [expense]
        };
      }
      return acc;
    }, {});
  }
);

export const makeGetExpensesByBookingId = () =>
  createSelector([getExpensesByBookingId], values => values);
